import Boom from 'boom'

import makeApi from '../client/api'
import sourceDataToAccount from './source-data-to-account'

export const authenticateUser = async (email, password) => {
  const { api } = makeApi()

  const { ok, data } = await api.post('/auth/local', { email, password })

  if (!ok) {
    throw data.error
  }

  const { access_token: accessToken, user } = data

  localStorage.setItem('accessToken', accessToken)

  return { accessToken, user }
}

export const authenticateCrawlerConversion = async (announcementId, { source, sourceId, token }) => {
  if (token) {
    const { api } = makeApi({ token })

    const { ok, data } = await api.get('/profile')

    if (ok) {
      return { accessToken: token, user: data.data }
    }
  }

  if (source && sourceId) {
    const { email, password } = sourceDataToAccount(source, sourceId, announcementId)
    return authenticateUser(email, password)
  }

  throw Boom.unauthorized()
}

export const registerUser = async (user) => {
  const { api } = makeApi()

  const { ok, data } = await api.post('/users', { ...user })

  if (!ok) {
    throw data.error
  }

  return data
}

export const authWithFacebook = async (token) => {
  const { api } = makeApi()
  const response = await api.post('/auth/facebook', { access_token: token })

  return response
}

export const connectFacebook = async (accessToken, facebookToken, forceSync) => {
  const { api } = makeApi({ token: accessToken })
  const response = await api.post('/auth/connect/facebook', {
    access_token: facebookToken,
    force_sync: forceSync,
  })

  return response
}

export const updateUser = async (user, token) => {
  const { api } = makeApi({ token })

  const response = await api.patch('/profile', { data: user, id: user.id })
  return response
}

export const newUpdateUser = async (updatedData, token) => {
  const api = makeApi({ token })

  return api.update('/profile', { data: updatedData, id: '' })
}

export const registerNewUser = async ({ name, email, password, phone, cpf }) => {
  const { api } = makeApi()

  const response = await api.post('/users', { name, email, password, phone, cpf })

  if (!response.ok) {
    if (response.status === 422) {
      throw Boom.forbidden('Form data incorrect', response.data)
    }
    throw Boom.forbidden()
  }

  return response.data
}

export const getUserBankAccount = async (userId, token) => {
  const { api } = makeApi({ token })

  const { ok, data, status } = await api.get(`/users/${userId}/bank-account`)

  if (!ok) {
    if (status === 404) {
      throw Boom.notFound('Entity not found')
    } else if (status === 422) {
      throw Boom.notFound('Form data incorrect', { details: data.details })
    }
    throw Boom.forbidden()
  }

  return data
}

export const createUserBankData = async (bankData, userId, token) => {
  const { api } = makeApi({ token })

  const { ok, data, status } = await api.post(`/users/${userId}/bank-account`, bankData)

  if (!ok) {
    if (status === 404) {
      throw Boom.notFound('Entity not found')
    } else if (status === 422) {
      throw Boom.notFound('Form data incorrect', { details: data.details })
    }
    throw Boom.forbidden()
  }

  return data
}

export const upsertUserBankAccount = async (token, userId, payload) => {
  const { api } = makeApi({ token })

  const { ok, data, status } = await api.post(`/users/${userId}/bank-account`, payload)

  if (!ok) {
    if (status === 401) {
      throw Boom.unauthorized()
    } else if (status === 422) {
      throw Boom.notFound('Form data incorrect', { details: data.details })
    }
    throw Boom.forbidden()
  }

  return data
}

export const requestConfirmationPin = async (phone, token) => {
  const { api } = makeApi({ token })

  const payload = {
    phone: `55${phone}`,
  }

  const { ok, data, status } = await api.post('/sms/pin', payload)

  if (!ok) {
    if (status === 401) {
      throw Boom.unauthorized()
    } else if (status === 422) {
      throw Boom.notFound('Form data incorrect', { details: data.details })
    }
    throw Boom.forbidden()
  }

  return data
}

export const verifyConfirmationPin = async ({ pinId, pin, userId, token }) => {
  const { api } = makeApi({ token })

  const payload = {
    pin,
    user_id: userId,
  }

  const { ok, data, status } = await api.post(`/sms/pin/${pinId}`, payload)

  if (!ok) {
    if (status === 401) {
      throw Boom.unauthorized()
    } else if (status === 422) {
      throw Boom.notFound('Form data incorrect', { details: data.details })
    }
    throw Boom.forbidden()
  }

  return data
}
